import { memo } from 'react';
import { Handle } from 'reactflow';
import "./styles.css";

const GreySquareNode = memo(({ data }) => {
  return (
    <div className="int__grey-square-node"
      style={{
        backgroundColor: "#4f4f4f",
        padding: "14px"
      }}>
      <Handle
        type="target"
        position="top"
        id="input"
        style={{ width: 0, height: 0, top: 2, border: "none", backgroundColor: "transparent" }}
      />
      <div
        style={{
          marginTop: "-10px",
          marginLeft: "-90px"
        }}>
        <input className="nodrag" type="text" defaultValue={data.label} onChange={event => data.label = event.target.value} style={{ textAlign: "center", width: 170, fontSize: 13 }} />
      </div>
      <Handle
        type="target"
        position="left"
        id="input_left"
        style={{ width: 0, height: 0, border: "none", backgroundColor: "transparent", top: 17, left: -75 }}
      />
      <Handle
        type="source"
        position="right"
        id="output_right"
        style={{ width: 0, height: 0, border: "none", backgroundColor: "transparent", top: 17, right: -65 }}
      />
      <Handle
        type="source"
        position="bottom"
        id="output"
        style={{ width: 0, height: 0, bottom: -10, border: "none", backgroundColor: "transparent" }}
      />
    </div>
  );
});

GreySquareNode.displayName = 'GreySquareNode';
export default GreySquareNode;